import { STORE_REPLACE_PINWHEEL_SURVEY_OPTIONS } from '@perpay-web/fintech/constants/actionTypes';

export function replacePinwheelSurveyOptions(payload) {
    return {
        type: STORE_REPLACE_PINWHEEL_SURVEY_OPTIONS,
        payload,
    };
}
